<template>
  <q-card flat>
    <q-card-section class="fixed-header-position q-pa-xs">
      <q-banner class="bg-blue text-white text-subtitle1" inline-actions>
        لیست موجودی کالاها
      </q-banner>
      <q-card>
        <q-card-section v-if="storeList && storeList.length>0" class="no-padding">
          <q-toggle v-model="item.selected" :value="item.selected" v-for="(item, index) in storeList" :key="index"
                    :label="item.StorName" @click="filterWithStoreID"/>
        </q-card-section>
        <q-card-section>
          <q-select
              v-model="selectedGoodsGroup"
              label="گروه کالا"
              :options="goodsGroupOptions"
              option-label="Group_Name"
              option-value="Group_ID"
              @filter="filterGoodsGroupFn"
              use-chips
              use-input
              multiple
          />
        </q-card-section>
        <q-card-actions>
          <q-btn label="اخذ گزارش" type="button" icon="search" color="primary" @click="getGoodsList"/>
          <q-btn label="چاپ" type="button"
                 v-if="$store.state.roles.some(v=>['admin'].includes(v)) && selectedGoodsGroup"
                 icon="print" color="primary" @click="loadReport"/>

          <q-btn
              v-if="selectedGoodsGroup && selectedGoodsGroup.length>0"
              label="خلاصه اطلاعات گروه کالایی" type="button" icon="group_work"
              color="secondary"
              @click="showGoodsGroupList"/>
          <vue-json-to-csv
              :json-data="goods"
              v-if="goods && goods.length>0 && $store.state.roles.some(v=>['admin','can_download_list'].includes(v))">
            <q-btn label="دانلود" icon="download" color="blue" flat class="q-ml-sm">
              <download-csv
                  name="inventoryList"
                  :data="goods">
                <span></span>
              </download-csv>
              <q-tooltip>
                دانلود گزارش
              </q-tooltip>
            </q-btn>
          </vue-json-to-csv>
        </q-card-actions>
      </q-card>
    </q-card-section>
    <q-card-section>
      <q-table
          flat
          :data="goods"
          row-key="ID"
          :wrap-cells="$q.screen.lt.md"
          :pagination="pagination"
          :filter="filter"
          :hide-header="$q.screen.lt.md"
          :filter-method="showExistsProduct">
        <template v-slot:header>
          <q-tr class="bg-blue-grey text-white">
            <td class="text-center text-subtitle2">کد کالا</td>
            <td class="text-center text-subtitle2">نام کالا</td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">قیمت خرید روز
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">قیمت خرید اصلی
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">تاریخ آخرین خرید
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">قیمت لیست
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">قیمت نقد کارتن
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">قیمت نقد بسته
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">قیمت اتحادیه
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <span>قیمت کل موجودی</span>
              <br/>
              <span>بر اساس قیمت خرید</span>
            </td>
            <td class="text-center text-subtitle2">کل</td>
            <td class="text-center text-subtitle2">مرکزی</td>
            <td class="text-center text-subtitle2">فروشگاه</td>
            <td class="text-center text-subtitle2">پل پنجم</td>
            <td class="text-center text-subtitle2">کارخانه صاف</td>
            <td class="text-center text-subtitle2">دیجیکالا</td>
            <td class="text-center text-subtitle2">ضایعات</td>
          </q-tr>
          <q-tr class="q-mb-md">
            <td class="text-center text-subtitle2">
            </td>
            <td class="text-center text-subtitle2">
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">

            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))"></td>
            <td></td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.Goods_Stock * item.List_Price).toLocaleString()"/>

            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.Goods_Stock * item.SaleG_Price_Box).toLocaleString()"/>

            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.Goods_Stock * item.SaleG_Price).toLocaleString()"/>
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.Goods_Stock * item.Price).toLocaleString()"/>
            </td>
            <td class="text-center text-subtitle2"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))" square
                      text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.Goods_Stock * item.BuyDay_Price).toLocaleString()"/>
            </td>

            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.Goods_Stock)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.GStor1)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.GStor2)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.GStor3)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.GStor4)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.GStor6)"/>
            </td>

            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goods, item=> item.GStor5)"/>
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr v-if="$q.screen.lt.md" :props="props" class="my-class">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <div class="row full-width">
                    <div class="col">
                      <q-card-section class="no-padding">
                        {{ props.row.title }}
                        <q-badge align="top" rounded v-if="props.row.EXISTSImage">
                          <q-icon name="wallpaper"/>
                        </q-badge>
                      </q-card-section>
                    </div>
                    <div class="col">
                      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="موجودی کل">
                        <q-badge :color="props.row.Goods_Stock===0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.Goods_Stock }}
                        </q-badge>
                      </q-chip>
                    </div>
                  </div>
                </q-card-section>
                <q-card-actions class="no-padding">
                  <q-btn round icon="info" padding="none" size="lg"
                         :color="props.row.Goods_Stock===0?'red':'indigo'"
                         @click="showProductDetailsDialog(props.row)"/>
                  <q-btn round icon="privacy_tip" flat padding="none" size="lg"
                         :color="props.row.Goods_Stock===0?'red':'indigo'"
                         @click="showCatexDialog(props.row)">
                    <q-tooltip>
                      بررسی کارتکس کالا
                    </q-tooltip>
                  </q-btn>
                  <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="lg" color="red"
                         v-if="props.row.Goods_SaleStatus!==50101">
                    <q-tooltip>
                      {{ props.row.General_Name }}
                    </q-tooltip>
                  </q-btn>
                  <q-btn class="q-mt-xs"
                         round flat icon="edit"
                         padding="none"
                         size="lg"
                         color="purple"
                         @click="showGoodsEditDialog(props.row)"
                         v-if="$store.state.roles.some(v=>['admin','can_edit_goods_exists'].includes(v))">
                    <q-tooltip>
                      اصلاح موجودی کالا
                    </q-tooltip>
                  </q-btn>
                </q-card-actions>

              </q-card>
            </q-td>
          </q-tr>
          <q-tr v-if="!$q.screen.lt.md" :props="props" class="my-class">
            <q-tooltip>
              {{ props.row.Goods_Name }}
            </q-tooltip>
            <q-td class="text-subtitle2 text-deep-orange text-center" style="width: 100px">
              <q-chip square dense color="red" text-color="white" clickable :label="props.row.Goods_Code"
                      @click="showProductDetailsDialog(props.row)"/>
              <q-space/>
              <q-chip v-if="props.row.GoEvent_StOut"
                      clickable
                      @click="showReserveList(props.row)"
                      :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'" square flat
                      label="رزرو">
                <q-badge color="red-10" text-color="white" class="q-ml-xs">
                  {{ props.row.GoEvent_StOut }}
                </q-badge>
              </q-chip>
            </q-td>
            <q-td style="width: 500px">
              {{ props.row.Goods_Name }}
              <q-space/>
              <q-btn round icon="privacy_tip" flat padding="none" size="lg"
                     :color="props.row.Goods_Stock===0?'red':'indigo'"
                     @click="showCatexDialog(props.row)"/>
              <q-btn class="q-mt-xs"
                     round flat icon="edit"
                     padding="none"
                     size="lg"
                     color="purple"
                     @click="showGoodsEditDialog(props.row)"
                     v-if="$store.state.roles.some(v=>['admin','can_edit_goods_exists'].includes(v))">
                <q-tooltip>
                  اصلاح موجودی کالا
                </q-tooltip>
              </q-btn>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip
                  v-if="props.row.BuyDay_Price && props.row.BuyDay_Price>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                  :label="props.row.BuyDay_Price.toLocaleString()" color="brown" text-color="white" square>
                <q-tooltip>
                  خرید روز
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip
                  v-if="props.row.BuyLast_Price && props.row.BuyLast_Price>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                  :label="props.row.BuyLast_Price.toLocaleString()" color="brown" text-color="white" square>
                <q-tooltip>
                  خرید اصلی
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip v-if="props.row.BuyDay_Date"
                      :label="props.row.BuyDay_Date" color="red" text-color="white" square>
                <q-tooltip>
                  تاریخ خرید روز
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip v-if="props.row.List_Price && props.row.List_Price>0"
                      :label="props.row.List_Price.toLocaleString()" color="purple" text-color="white" square>
                <q-tooltip>
                  قیمت لیست
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip v-if="props.row.SaleG_Price && props.row.SaleG_Price>0"
                      :label="props.row.SaleG_Price.toLocaleString()" color="blue" text-color="white" square>
                <q-tooltip>
                  قیمت نقد کارتن
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip v-if="props.row.SaleG_Price_Box && props.row.SaleG_Price_Box>0"
                      :label="props.row.SaleG_Price_Box.toLocaleString()" color="blue" text-color="white" square>
                <q-tooltip>
                  قیمت نقد بسته
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip v-if="props.row.Price && props.row.Price>0"
                      :label="(props.row.Price).toLocaleString()" color="green" text-color="white" square>
                <q-tooltip>
                  قیمت اتحادیه
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center"
                  v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
              <q-chip
                  v-if="(props.row.Goods_Stock * props.row.BuyDay_Price) && (props.row.Goods_Stock * props.row.BuyDay_Price)>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                  :label="(props.row.Goods_Stock * props.row.BuyDay_Price).toLocaleString()" color="red-14"
                  text-color="white" square>
                <q-tooltip>
                  قیمت کل موجودی بر اساس قیمت خرید
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center" style="width: 100px">
              <q-chip v-if="props.row.Goods_Stock" :label="props.row.Goods_Stock" text-color="white" color="teal">
                <q-badge v-if="props.row.GoEvent_StOut>0" class="q-ml-xs" color="red-10" text-color="white"
                         :label="props.row.GoEvent_StOut"/>
              </q-chip>
              <q-tooltip>
                دارای موجودی رزرو
              </q-tooltip>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor1" :label="props.row.GStor1" text-color="white" color="purple">
                <q-badge
                    v-if="props.row.ReserveGoodsInStore &&
                    JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===1).length>0"
                    class="q-ml-xs" color="red-10" text-color="white"
                    :label="JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===1)[0].GoEvent_StOut"/>
              </q-chip>
              <q-tooltip>
                مرکزی
              </q-tooltip>

            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor2" :label="props.row.GStor2" text-color="white" color="blue-grey">
                <q-badge
                    v-if="props.row.ReserveGoodsInStore &&
                    JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===2).length>0"
                    class="q-ml-xs" color="red-10" text-color="white"
                    :label="JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===2)[0].GoEvent_StOut"/>
              </q-chip>
              <q-tooltip>
                فروشگاه
              </q-tooltip>

            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor3" :label="props.row.GStor3" text-color="white" color="grey">
                <q-badge
                    v-if="props.row.ReserveGoodsInStore &&
                    JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===3).length>0"
                    class="q-ml-xs" color="red-10" text-color="white"
                    :label="JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===3)[0].GoEvent_StOut"/>
                <q-tooltip>
                  پل پنجم
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor4" :label="props.row.GStor4" text-color="white" color="blue">
                <q-badge
                    v-if="props.row.ReserveGoodsInStore &&
                    JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===4).length>0"
                    class="q-ml-xs" color="red-10" text-color="white"
                    :label="JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===4)[0].GoEvent_StOut"/>
                <q-tooltip>
                  کارخانه صاف
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor6" :label="props.row.GStor6" text-color="white" color="blue">
                <q-badge
                    v-if="props.row.ReserveGoodsInStore &&
                    JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===4).length>0"
                    class="q-ml-xs" color="red-10" text-color="white"
                    :label="JSON.parse(props.row.ReserveGoodsInStore).filter(item=> item.StorID===4)[0].GoEvent_StOut"/>
                <q-tooltip>
                  دیجیکالا
                </q-tooltip>
              </q-chip>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor5" :label="props.row.GStor5" text-color="white" color="blue">
                <q-tooltip>
                  انبار ضایعات
                </q-tooltip>
              </q-chip>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog
        :full-width="$q.screen.lt.md?true:false"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>

    <q-dialog maximized v-model="showCartex">
      <GoodsCartex :goods-info="selectedProductDetails"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsEditDialog">
      <GoodsStore :goods-info="selectedProductDetails"/>
    </q-dialog>

    <q-dialog maximized v-model="goodsGroupDialog">
      <GroupInventoryList :goods-group-code="selectedGoodsGroup"/>
    </q-dialog>

    <q-dialog v-model="showReserveDialog" :maximized="$q.screen.lt.md">
      <ReserveExiList :goods-info="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import GoodsCartex from "@/components/store/GoodsCartex";
import VueJsonToCsv from 'vue-json-to-csv'
import GroupInventoryList from "@/components/products/GroupInventoryList";
import GoodsStore from "@/components/store/GoodsStore";
import ReserveExiList from "@/components/products/ReserveExiList";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "Inventorylist",
  components: {ProductDetail, ReserveExiList, GoodsStore, GroupInventoryList, GoodsCartex, VueJsonToCsv},
  data() {
    return {
      storeList: [],
      showReserveDialog: false,
      goodsGroupDialog: false,
      showProductDetails: false,
      showCartex: false,
      selectedProductDetails: null,
      selectedGoodsGroup: null,
      goods: [],
      goodsGroup: [],
      goodsGroupOptions: [],
      pagination: {
        rowsPerPage: 10
      },
      filter: 'false',
      goodsEditDialog: false
    }
  },
  methods: {
    ...mapActions({
      setGoodsGroup: 'Products/getGoodsGroup',
      setGoodsList: 'Products/getGoodsList',
      setStoreList: 'Products/getStoreList'
    }),
    async loadReport() {
      if (!this.selectedGoodsGroup) return
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش لیست موچودی کالا?rs:Format=PDF&GroupIds=${this.selectedGoodsGroup.map(rec=> rec.Group_ID).join(',')}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showGoodsEditDialog(row) {
      this.selectedProductDetails = row;
      this.goodsEditDialog = true;
    },
    showGoodsGroupList() {
      this.goodsGroupDialog = true;
    },
    filterGoodsGroupFn(val, update) {
      update(() => {
        this.goodsGroupOptions = this.goodsGroup.filter(item => item.Group_Name.includes(val))
      })
    },
    getGoodsList() {
      this.setGoodsList({
        goodsGroup: this.selectedGoodsGroup,
        selectedStore: this.storeList.filter(item => item.selected)
      }).then((res) => {
        this.goods = res;
        this.goodsOptions = this.goods;
      })
    },
    showExistsProduct(data) {
      if (data.length > 0) {
        if (this.filter === 'true') {
          return data.filter(row => row.Goods_Stock > 0);
        } else {
          return data;
        }
      }
      return data;
    },
    showCatexDialog(row) {
      this.selectedProductDetails = row
      this.showCartex = true;
    },
    showProductDetailsDialog(row) {
      this.selectedProductDetails = row;
      this.showProductDetails = true
    },
    showReserveList(data) {
      this.selectedProductDetails = data
      this.showReserveDialog = true
    },
    filterWithStoreID() {
    }
  },
  watch: {
    selectedGoodsGroup: function (val) {
      if (!val || val.length === 0) {
        this.goods = []
      }
    },
  },
  created() {
    this.setGoodsGroup().then((res) => {
      this.goodsGroup = res
      this.goodsGroupOptions = this.goodsGroup
    })
    this.setStoreList().then((res) => {
      res.forEach(record => record.selected = false)
      this.storeList = res;
    })
  }
}
</script>

<style>
.fixed-header-position {
  position: sticky;
  top: 0;
  z-index: 1000
}
</style>